// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-container[data-v-438d69e5]{width:150px}select[data-v-438d69e5]{border:none;border-radius:0;background:#eceff3;font-weight:700}.form-control[data-v-438d69e5]:focus{border-color:#ced4da!important;box-shadow:none!important}.per-page-select[data-v-438d69e5]{display:inline}.per-page-text[data-v-438d69e5]{display:inline;font-size:12px;color:#9fa7af;margin-right:10px}", ""]);
// Exports
module.exports = exports;
